export const PopularTestsConfig = [
    {
        span: 5,
        height: "40px",
        classes: "marginTop-40",
    },
    {
        span: 4,
        height: "40px",
        classes: "marginTop-16",
    },
    {
        span: 5,
        height: "40px",
        classes: "marginTop-8",
    },
    {
        span: 5,
        height: "40px",
        classes: "marginTop-8",
    },
    {
        span: 4,
        height: "40px",
        classes: "marginTop-16",
    },
    {
        span: 5,
        height: "40px",
        classes: "marginTop-8",
    },
    {
        span: 5,
        height: "40px",
        classes: "marginTop-4",
    },
]
